// App.js
import React, { useState } from 'react';
import './App.css';
import EncoderComponent from './encoderComponent';
import DecoderComponent from './decoderComponent';

function App() {
  const [isEncoder, setIsEncoder] = useState(true);

  return (
    <div className="app-container">
      <nav className="navbar">
        <div className="navbar-content">
          <h2 className="navbar-title">खुसुक्क</h2>
          <button className="switch-button" onClick={() => setIsEncoder(!isEncoder)}>
            {isEncoder ? 'Switch to Decoder' : 'Switch to Encoder'}
          </button>
        </div>
      </nav>
      <div className="main-content">
        {isEncoder ? <EncoderComponent /> : <DecoderComponent />}
      </div>
      <div className="stars">
        {Array.from({ length: 50 }).map((_, index) => (
          <div key={index} className="star"></div>
        ))}
      </div>
    </div>
  );
}

export default App;